import React from 'react';
import { connect } from 'react-redux';
import UsersStatsMPGTBWidget from "../Widgets/UsersStats";
import CommentsModerationWidget from "../Widgets/CommentsModeration";
import RankingMPGTBWidget from "../Widgets/Ranking";
import '../index.css';

const MPGTBDashboard = () => (
    <div id="MPGTB">
        <header className="content-header">
            <h1>
                Dashboard
                <small>MPG TB</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-trophy"/> MPGTB</li>
            </ol>
        </header>
        <section className="content">
            <div className="row">
                <div className="col-md-12">
                    <UsersStatsMPGTBWidget />
                </div>
                <div className="col-md-6">
                    <CommentsModerationWidget />
                </div>
                <div className="col-md-6">
                    <RankingMPGTBWidget />
                </div>
            </div>
        </section>
    </div>
);

export default connect(
    state => ({}),
    dispatch => ({ dispatch }),
)(MPGTBDashboard);



// WEBPACK FOOTER //
// ./src/pages/Other/MPGTB/Dashboard/index.js